"use client"

import React from "react"

import EmptyFilteredContent from "compositions/events/EmptyFilteredContent/EmptyFilteredContent"

import useFilteredLeagues from "./utils/useFilteredLeagues"
import OvertimeLeague from "../League/OvertimeLeague"
import useChainProviderHook from "@/hooks/useChainProvider"

type OvertimeFilteredLeaguesProps = {
  sportSlug: string
  leagues: any
  isPage?: boolean
  showFilter?: boolean
  isFirstSport?: boolean
}

const OvertimeFilteredLeagues: React.FC<OvertimeFilteredLeaguesProps> = ({
  sportSlug,
  leagues,
  isPage,
  showFilter = false,
  isFirstSport = false,
}) => {
  const { isOvertimeChain } = useChainProviderHook()
  const filteredLeagues = useFilteredLeagues(leagues, isOvertimeChain)

  if (!filteredLeagues?.length) {
    return <EmptyFilteredContent />
  }

  return (
    <>
      {filteredLeagues.map((league, index) => (
        <OvertimeLeague
          key={`${league.countrySlug}-${league.slug}`}
          sportSlug={sportSlug}
          league={league}
          isPage={isPage}
          showFilter={showFilter}
          isFirstLeague={isFirstSport && index === 0}
        />
      ))}
    </>
  )
}

export default OvertimeFilteredLeagues
